import { render } from "./Notify.vue?vue&type=template&id=6e859b8c&scoped=true"
import script from "./Notify.vue?vue&type=script&lang=js"
export * from "./Notify.vue?vue&type=script&lang=js"

import "./Notify.vue?vue&type=style&index=0&id=6e859b8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e859b8c"

export default script